import { placeholderImage } from './placeholder-image.js';
import { isPresent } from './type-guards.js';

// Packshot image type
const FRONT_IMAGE = 'Front';
/**
 * Returns Front image if it's set, otherwise placeholder image
 */ function getFrontImage(images) {
    if (!isPresent(images) || !images.length) {
        return placeholderImage;
    }
    const frontImage = images.find((image)=>image.label === FRONT_IMAGE
    );
    var ref;
    return (ref = frontImage !== null && frontImage !== void 0 ? frontImage : images[0]) !== null && ref !== void 0 ? ref : placeholderImage;
}

export { getFrontImage as default };
//# sourceMappingURL=get-front-image.js.map
